function AdminVehiclesController($scope, $state) {

}

AdminVehiclesController.$inject = ['$scope', '$state'];
export default AdminVehiclesController;